export default [
  {
    path: '/admin/info-ann/info-ann-management/index',
    name: 'M020065',
    component: () =>
      import('@/views/admin/info-ann/info-ann-management/AnnounceIndex.vue'),
    meta: { layout: 'admin' },
  },
];
